import { render } from "./PrimaryBadge.vue?vue&type=template&id=8a9f8216"
import script from "./PrimaryBadge.vue?vue&type=script&lang=js"
export * from "./PrimaryBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__